import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import { hasRouteAccess } from '../utils/sidebarAccess';
import { useGetMeQuery } from '../store/api';

export default function Layout() {
  const location = useLocation();
  const { data: userData } = useGetMeQuery();
  const user = useSelector((state) => state.auth.user) || userData?.data;
  const canAccess = hasRouteAccess(location.pathname, user?.allowedRoutes);
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  const fallbackRoute = React.useMemo(() => {
    if (!user) return "/";
    const { getVisibleSidebarItems } = require("../utils/sidebarAccess");
    const visibleItems = getVisibleSidebarItems(user.allowedRoutes);
    return visibleItems.length > 0 ? visibleItems[0].route : "/";
  }, [user]);

  if (user && !canAccess) {
    return <Navigate to={fallbackRoute} replace />;
  }

  return (
    <div className="flex min-h-screen bg-white relative">
      <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />

      <div className="flex-1 flex flex-col min-h-screen w-full md:w-[calc(100%-288px)]">
        <Navbar toggleSidebar={() => setIsSidebarOpen(true)} />
        <main className="overflow-auto flex-1 relative">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
